export default __webpack_public_path__ + "static/media/JavaScript.0a9970ab.png";